<main class="py-16">

    <section id="program-login" class="container mx-auto max-w-screen-xl prose leading-normal px-8 xl:px-0">
        <div class="program-login__intros flex justify-center gap-x-16">

            <div class="program-login__main md:basis-2/4">
                <p class="text-[22px] sm:text-[24px] mt-0 md:mt-8"><em>Forgot Password</em></p>
                <p class="text-[22px] sm:text-[24px] mt-0 md:mt-8" *ngIf="!IsSendForgotPasswordLink">Please enter your email to receive instructions on how to reset your password.</p>
                <div class="program-login__form grid grid-cols-1 gap-6 mt-8" *ngIf="!IsSendForgotPasswordLink">
                    <label for="emailAddress" class="block">
                        <span>Email Address</span>
                        <input id="emailAddress" name="emailAddress" type="email" class="mt-1 block w-full" placeholder="" [(ngModel)]="emailaddress" required email #emailInput="ngModel" (focusout)="validateUser()"/>
                        <!-- <div *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)" class="mt-2 text-red-500">
                            <div *ngIf="emailInput.errors?.['required']">Please enter email address.</div>
                            <div *ngIf="emailInput.errors?.['email']">Please enter a valid email address.</div>
                        </div> -->
                        <span class="mt-2 errMsg text-red-500" *ngIf="showEmailErr">
                            {{showEmailMsg}}
                        </span>
                    </label>
                    <!-- <label for="password" class="block idden">
                    <span><span class="required-asterisk">*</span>Password</span>
                    <input id="password" name="password" type="password" class="mt-1 block w-full" placeholder="" required />
                </label> -->

                    <div class="program-login__submit gap-6">
                        <button id="btnSubmit" type="button" class="btn__blue" [disabled]="emailInput.invalid" (click)="submitForm()" data-measurement="SSP - Login - Submit">Submit</button>
                    </div>
                </div>
                <div class="program-login__form grid grid-cols-1 gap-6 mt-8" *ngIf="IsSendForgotPasswordLink">
                    <div class="text-[22px] sm:text-[24px] mt-0 md:mt-8"><strong>Password reset link sent successfully!</strong></div>
                    <div class="program-login__submit">
                        <button id="backbtn" type="button" class="btn__blue" (click)="redirectToLogin()">Back to Login</button>
                    </div>
                </div>
                <!--<div class="program-login__forgot">
                    <p class="mb-16 md:mb-8">
                        If you do not receive a password email at the email address that you entered, please 
                        <a id="forgotPassword" href="mailto:campaigns.support@syngenta.com?subject=Storen%20Satisfaction%20Program%20-%20Support%20Request">contact Storen Customer Service.</a>
                    </p>
                </div>-->
            </div>
        </div>
    </section>
</main>

